export default __webpack_public_path__ + "../staticImages/audi_rings-black.svg";